// Third-party imports
import $ from 'jquery';
import '@accessible360/accessible-slick';

// Module name
export const MODULE_NAME = 'recommended';

export let global_vars = {};

// Called directly after the API call is complete to ensure that the slider is initialzed at the correct time
function recommendedSlider() {
    let slickElement = $('.recommended-slideshow');
    slickElement.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
    });
}

export function initialize() {
    let loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        let productRecommendationsSection = document.querySelector(
            '.product-recommendations'
        );
        if (productRecommendationsSection === null) {
            return;
        }
        // Read product id from data attribute
        let productId = productRecommendationsSection.dataset.productId;
        // Read limit from data attribute
        let limit = productRecommendationsSection.dataset.limit;
        // Build request URL
        let requestUrl =
            '/recommendations/products?section_id=product-recommendations&limit=' +
            limit +
            '&product_id=' +
            productId;
        // Create request and submit it using Ajax
        let request = new XMLHttpRequest();
        request.open('GET', requestUrl);
        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                let container = document.createElement('div');
                container.innerHTML = request.response;
                productRecommendationsSection.parentElement.innerHTML = container.querySelector(
                    '.product-recommendations'
                ).innerHTML;
            }
            recommendedSlider();
        };
        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener('shopify:section:load', function(event) {
        if (event.detail.sectionId === 'product-recommendations') {
            loadProductRecommendationsIntoSection();
        }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
}
